import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component } from "react";
import { Button,Card,Breadcrumb,Form,Table,ButtonGroup,ButtonToolbar } from "react-bootstrap";
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { Col, CardBody } from "reactstrap";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;

class EditCompliant extends Component {

  constructor(props) {
    super(props);
    this.state = {
		customerType: "",
		customerCode: "",
		parentList: [],
		childList: [],
		othersid: "",
		parentid: "",
		childid: "",
		note: "",
		ticketId: this.props.data ? this.props.data : (this.props.location.state.data ? this.props.location.state.data : ''),
		editTicketDetails: "",
		childcategorystatus: "",
		disableChild: "",
		minimumLetterNote: "",
		powerBackupDeviceId: ""
	};
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }
  nextPath(path) {
    this.props.history.push({ pathname: path });
  }
  componentDidMount() {
	let postOrderData = "";
	let childList = []
	postOrderData = { 
	"ticket_id": this.state.ticketId,
	}
	const urltick = process.env.REACT_APP_NODE_ENV + "/api/compliant/compliantticketview";
    fetch(urltick,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
	body: JSON.stringify(postOrderData)
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
       this.setState({ editTicketDetails: data.data })
       this.setState({ customerCode: data.data.user_id })
       this.setState({ parentid: data.data.parent_id })
       this.setState({ childid: data.data.child_id })
       this.setState({ note: data.data.note })
       this.setState({ childcategorystatus: data.data.ticket_status })
		
		let postOrderData = "";
		let childList = []
		postOrderData = { 
		"parent_id": data.data.parent_id,
		}
		const url1 = process.env.REACT_APP_NODE_ENV + "/api/compliant/getchildbyparentid";
		fetch(url1,{
		  method:'POST',
		  headers: {
			'Content-Type': 'application/json',
			'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		  },
		body: JSON.stringify(postOrderData)
		}).then(
		  response => {
			return response.json();
		  }
		).then(data => {
			
		   childList = data.data.map(data => (
			<option key={data.id} value={data.id}>{data.child_category}</option>
			
		  ))
		this.setState({ childList: childList })
		})
		
		if(data.data.parent_id){
			const urls = process.env.REACT_APP_NODE_ENV + "/api/compliant/activeparentlist";
			fetch(urls,{
			  method:'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  }
			}).then(
			  response => {
				return response.json();
			  }
			).then(data => {
				for(var i=0; i<data.data.length; i++){	
					if(data.data[i].parent_category === 'Others'){
						this.setState({ othersid: data.data[i].id })
					}
					if(this.state.parentid.toString() === data.data[i].id.toString()){
						if(data.data[i].parent_category === 'Others'){
							// alert('disabled')
							this.setState({ disableChild: 'disable', childid:'1' })
						}				
					}
				}
			   this.setState({ parentList: data.data })
			})
		}
    })
	
	
	
	const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/fetchAll/"
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ apartmentUserInput: data });
      }).catch(error => this.setState({ apartmentUserInput: [] }))

      const url2 = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/fetchAll/"
      fetch(url2, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ corporateUserInput: data });
      }).catch(error => this.setState({ corporateUserInput: [] }))
	  
      const url3 = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/fetchAll/"
      fetch(url3, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ individualUserInput: data });
      }).catch(error => this.setState({ individualUserInput: [] }))
	
  }
  
   changeParent = (event) => {
    this.setState({ parentid: event.target.value })
	this.setState({ childid: "" })
	if(event.target.value === this.state.othersid.toString()){
		this.setState({ disableChild: 'disable', childid:'1' })
	}else{
		this.setState({ disableChild: '', childid:'' })
	}
	let postOrderData = "";
	let childList = []
	postOrderData = { 
	"parent_id": event.target.value,
	}
	const url1 = process.env.REACT_APP_NODE_ENV + "/api/compliant/getchildbyparentid";
    fetch(url1,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
	body: JSON.stringify(postOrderData)
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
      
	   childList = data.data.map(data => (
        <option key={data.id} value={data.id}>{data.child_category}</option>
		
      ))
	this.setState({ childList: childList })
    })
  }

handleSelectFormFields = selectedOption => { 
	
	switch (selectedOption.id) {
		case "customerType":
			this.setState({ customerType: selectedOption.value })
			break;
		case "customerCode":
			this.setState({ customerCode: selectedOption.value })
			break;
      default: break;
    }
}

 handleEditFormFields = (event) => { 
    this.setState({ childid : event.target.value })
  }
  
handleTextarea = (event) => { 
    this.setState({ note : event.target.value })
	this.setState({ minimumLetterNote: <div class="text-info float-right">{event.target.value.length}/250</div> });
  }
handleSelectStatus= (event) => { 
    this.setState({ childcategorystatus : event.target.value })
  }

  createCompliant = () => {
	if(this.validator.allValid()) {
		if(this.state.note.length <= 250){
			this.setState({ disableSubmit: true });
			const postCustData = {
			  "t_id": this.state.ticketId,
			  "user_id": this.state.customerCode,
			  "parent_id": this.state.parentid,
			  "child_id": this.state.childid,
			  "note": this.state.note,
			  "status": this.state.childcategorystatus,
			  "othersid": this.state.othersid.toString(),
			};
			fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/editticket', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  },
			  body: JSON.stringify(postCustData)
			}).then((res) => res.json())
			  .then((data) => {
				this.props.history.push({ pathname: "/register-compliant/compliant-list" });
				toast.success("Complaint Updated Successfully.", {
				  position: toast.POSITION.TOP_CENTER,
				});
			}).catch((err) => console.log(err))
		}else{
			this.setState({ minimumLetterNote: <div class="text-danger">Please write only 250 characters.</div> });
		}
	}else{
		if(this.state.note){
			if(this.state.note.length > 250){
				this.setState({ minimumLetterNote: <div class="text-danger">Please write only 250 characters.</div> });
			}
		}
      this.validator.showMessages(); 
    }
}
  
	popUpCancel1 = () => {
	  this.props.history.push({ pathname: "/register-compliant/compliant-list" });
	}

  

  render() {
	 const customerType = this.state.customerType;
	let parentList = this.state.parentList.map(data => (
        <option key={data.id} value={data.id}>{data.parent_category}</option>
      ))
	// let customerTypeData = [
      // { id: "customerType", label: "Apartment Customer", value: "Apartment_Customer" },
           // { id: "customerType", label: "Individual Customer", value: "Individual_Customer" },
      // { id: "customerType", label: "Corporate Customer", value: "Corporate_Customer" }]
	  
	// let customerData1 = [];
    // if (customerType === "Apartment_Customer") {
		// console.log(this.state.apartmentUserInput)
      // this.state.apartmentUserInput.map(data => {
        // let sddData = { id: "customerCode", label: data.apartmentName+" ("+data.apartmentId+")", value: data.apartmentId }
        // customerData1.push(sddData)
        // return null;
      // })
    // } else if (customerType === "Corporate_Customer") {
      // this.state.corporateUserInput.map(data => {
        // let sddData = { id: "customerCode", label: data.companyName+" ("+data.corporateId+")", value: data.corporateId }
        // customerData1.push(sddData)
        // return null;
      // })
    // } else if (customerType === "Individual_Customer") {
      // this.state.individualUserInput.map(data => {
        // let sddData = { id: "customerCode", label: data.name+" ("+data.individualId+")", value: data.individualId }
        // customerData1.push(sddData)
        // return null;
      // })
    // }
	
    return (<>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => this.nextPath("/register-compliant/compliant-list")}
        >
         Compliant List
          </Breadcrumb.Item>

        <Breadcrumb.Item active>Edit Compliant</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
      </div>

      <div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <form className="kt-form" id="kt_form" >
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
				<div className="kt-heading kt-heading--md">Edit Compliant</div>
				<div className="kt-form__section kt-form__section--first">
					<div className="kt-wizard-v1__form">
						<div className="form-group row">
							<div className="col-lg-6">
								<label>Parent Category *</label>
								
								
								<select name="parent Complaint" id="parentid"  name="parentid" className="form-control" value={this.state.parentid} onChange={this.changeParent} >
									<option value="">Select Parent Category</option>
									{parentList}
								</select>
								{
									this.validator.message('parent Category', this.state.parentid, 'required')
								}
							</div>

							<div className="col-lg-6" style={{display: this.state.disableChild == "" ? "block":'none'}}>
								<label>Child Category </label>
								<select name="child Complaint" id="childid"  name="childid" className="form-control" value={this.state.childid} onChange={this.handleEditFormFields} disabled={this.state.disableChild == "" ? "":this.state.disableChild}>
									<option value="">Select Child Category</option>
									{this.state.childList}
								</select>
								{
									this.validator.message('Child Category', this.state.childid, 'required')
								}
							</div>
						</div>
				
						<div className="form-group row">
							<div className="col-lg-12">
								<Form.Group controlId="exampleForm.ControlTextarea1">
									<Form.Label>Note *</Form.Label>
									<Form.Control as="textarea" rows="3" id="note" name="note" value={this.state.note} onChange={this.handleTextarea}/>
									{
										this.validator.message('Note', this.state.note, 'required')
									}
									{this.state.minimumLetterNote}
								</Form.Group>
							</div>
						</div>
						<div className="col-lg-8">
						  <label> <b>Status</b> </label><select id="childcategorystatus"  name="childcategorystatus" className="form-control" value={this.state.childcategorystatus} onChange={this.handleSelectStatus} >
							<option value="Pending">Pending</option>
							<option value="In Progress">In Progress</option>
							<option value="Closed">Closed</option>
						  </select>    
							{
								this.validator.message('Status', this.state.childcategorystatus, 'required')
							}
						</div>
					</div>
				</div>
            </div>
			
            <div className="kt-form__actions" style={{float: "right"}}>
                <Button variant="outline-primary" onClick={() => this.createCompliant()}> Save </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel1()}> Cancel </Button>
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
    </>
    );
  }
} 

export default EditCompliant;